<template>
  <div id="app">
    <h1> TinyPNG 使用 </h1>
    <div style="display: flex;
    margin-top: 50px; flex-direction: column; width: 820px;">
      <div style="position: relative">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础使用" name="base">
            <Base :quality="quality" />
          </el-tab-pane>
          <el-tab-pane label="jpeg/jpg" name="jpeg">
            <Jpeg :quality="quality" />
          </el-tab-pane>
          <el-tab-pane label="WebWork" name="webwork">
            <WebWork :quality="quality" />
          </el-tab-pane>

          <el-tab-pane label="CompressWorker" name="compressWorker">
            <CompressWorker :quality="quality" />
          </el-tab-pane>
        </el-tabs>
        <div style="position: absolute; right: 10px; top: 10px; ">
          <el-link size="mini" type="primary" href="https://tinypng.wcrane.cn"
            target="_blank">快速开始</el-link>
        </div>
      </div>
      <div style="display: flex; margin-top: 40px;">
        <div style="display: flex; flex: 1; justify-content: flex-start;  align-items: center;">
          <div>压缩质量（1-100）</div>
          <el-input-number size="small" v-model="quality" :min="1" :step="10" :max="100" label=""></el-input-number>
        </div>
        <div style="text-align: left; flex:1; display: flex; align-items: center;">
          计数：{{ count }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Base from './components/Base.vue';
import WebWork from './components/WebWork.vue';
import Jpeg from './components/Jpeg.vue';
import CompressWorker from './components/CompressWorker.vue';



export default {
  name: 'App',
  components: {
    Base,
    WebWork,
    Jpeg,
    CompressWorker
  },
  data() {
    return {
      activeName: 'base',
      count: 0,
      quality: 50
    };
  },
  mounted() {
    // 计数器
    setInterval(() => {
      this.count++
    }, 500)
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>